import { useMemo, useState } from 'react'
import { Box, Typography } from '@mui/material'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import { DOCUMENTS_DEFAULT_VIEW } from './documentsConstants'
import DocumentsGrid from './DocumentsGrid'
import DocumentsTable from './DocumentsTable'
import DocumentsToolbar from './DocumentsToolbar'
import { filterDocumentItems } from './filterDocumentItems'
import styles from './documentsPage.module.scss'
import { useDocumentsLibrary } from './useDocumentsLibrary'

/**
 * @param {{
 *   pickerMode?: boolean,
 *   inDialog?: boolean,
 *   selectedIds?: Set<string>,
 *   onToggleSelect?: (id: string) => void,
 * }} props
 */
export default function DocumentsBrowser({
  pickerMode = false,
  inDialog = false,
  selectedIds,
  onToggleSelect,
}) {
  const [query, setQuery] = useState('')
  const [activeCategory, setActiveCategory] = useState('all')
  const [view, setView] = useState(DOCUMENTS_DEFAULT_VIEW)
  const { items: libraryItems } = useDocumentsLibrary()

  const items = useMemo(
    () => filterDocumentItems(libraryItems, { query, category: activeCategory }),
    [libraryItems, query, activeCategory],
  )

  const pageClassName = [
    styles.page,
    inDialog ? styles.pageInDialog : '',
    pickerMode ? styles.pagePicker : '',
  ]
    .filter(Boolean)
    .join(' ')

  const listProps = pickerMode ? { pickerMode: true, selectedIds, onToggleSelect } : {}

  return (
    <Box className={pageClassName}>
      <header className={styles.topBar}>
        <Typography
          id={inDialog ? 'documents-picker-title' : undefined}
          component="h1"
          className={styles.title}
        >
          Documents
        </Typography>
        <Box className={styles.searchWrap}>
          <SearchRow value={query} onChange={setQuery} placeholder="Search" />
        </Box>
      </header>
      <DocumentsToolbar
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
        view={view}
        onViewChange={setView}
      />
      <Box className={styles.content}>
        {view === 'grid' ? (
          <DocumentsGrid items={items} {...listProps} />
        ) : (
          <DocumentsTable items={items} {...listProps} />
        )}
      </Box>
    </Box>
  )
}
